export const spinnerOverlayDefaultStyle = (theme, fullScreen) => ({
  width: !fullScreen ? '100%' : null,
  height: !fullScreen ? '100%' : null,
  minWidth: '180px',
  minHeight: '180px',
  padding: '16px',
  gap: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  backgroundColor: !fullScreen ? 'rgba(74,74,74,0.8)' : '',
  position: !fullScreen ? 'absolute' : '',
  zIndex: !fullScreen ? '1300' : '',
  top: !fullScreen ? '0' : '',
  bottom: !fullScreen ? '0' : ''
});